import { render, staticRenderFns } from "./createEmployee.vue?vue&type=template&id=630fb2a8&"
import script from "./createEmployee.vue?vue&type=script&lang=js&"
export * from "./createEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports